import HttpRequest from './http_request'
import { getStoreId } from '@/utils/helper/localStorage'
import storeId from '@/config/new-member-store.js'
class PrintProvider extends HttpRequest {
  constructor () {
    super(`${process.env.PRINT_API}`)
  }

  async getPrinters (branchId) {
    const newStore = storeId[getStoreId()] ? storeId[getStoreId()] : '000000000'
    const { data } = await this.get(`/public/${newStore.id}/printers/${branchId}`)
    return data
  }

  async printReceipt (payload) {
    const newStore = storeId[getStoreId()] ? storeId[getStoreId()] : '000000000'
    const { data } = await this.create(`/public/${newStore.id}/prints/receipt`, payload)
    return data
  }

  async printReportZ (payload) {
    const newStore = storeId[getStoreId()] ? storeId[getStoreId()] : '000000000'
    const { data } = await this.create(`/public/${newStore.id}/prints/report-z`, payload)
    return data
  }
}

export default PrintProvider



// WEBPACK FOOTER //
// ./src/resources/print_provider.js